import React from 'react';
import { WrappedMessage } from '../../../../utils';
import messages from '../../../displayMessages';
import { CareerOverview, CareerOverviewCard } from 'labxchange-client';
import { Icon } from 'elements';
import PulseCard from 'career-explorer/components/PulseCard';
import { useColor } from 'career-explorer/ThemeProvider';

interface BasicsPillProps  {
    careerCard: CareerOverviewCard;
}

export const BasicPill: React.FC<BasicsPillProps> = ({careerCard}) => {
    const { setSelectedColor } = useColor();

    const handleNodeClick = () => {
        setSelectedColor({backgroundColor: '#E2F5F3', iconColor: '#33B7A7'});

        if (careerCard.targetSection) {
            const targetElement = document.getElementById(careerCard.targetSection);
            if (targetElement) {
                setTimeout(() => {
                    targetElement.scrollIntoView({behavior: 'smooth'});
                }, 700);
            }
        }
    };

    const handleReadMore = () => {
        handleNodeClick();
    };

    return (
        <PulseCard onClick={handleNodeClick}>
            <div className='pill'>
                <div className='pill-content'>
                    <div className='pill-info'>
                        <div className='pill-title'>
                            <div className='pill-info-subtitle'>{careerCard.subTitle}</div>
                            <h4 className='pill-info-title'>{careerCard.title}</h4>
                        </div>
                        {careerCard.iconName &&
                            <div className='pill-icon'>
                                <Icon name={careerCard.iconName} zoom='28px' fill='#33B7A7' />
                            </div>
                        }
                    </div>
                    <div className='pill-info-description'>
                        {careerCard.description}&nbsp;
                        {careerCard.targetSection &&
                            <button onClick={handleReadMore} className='read-more-button'>
                                <WrappedMessage message={messages.readMoreBasicSummary}/>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </PulseCard>
    );
};

interface CareerOverviewProps {
    overview: CareerOverview;
}

const CareerOverviewSection: React.FC<CareerOverviewProps> = ({overview}) => {
    return (
        <div className='career-overview-section'>
            <h2>
                <WrappedMessage message={messages.careerOverviewSectionHeading} />
            </h2>
            <div className='career-overview-container'>
                {overview.overviewCards.map((card) => (
                    <BasicPill key={card.id} careerCard={card}/>
                ))}
            </div>
        </div>
    );
};

export default CareerOverviewSection;
